
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Event, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class EventListProvider implements Resolve<any> {
    event: Event[];
    eventEdit: Event;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.eventEdit = this.state?.currentEvent;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'dated';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<Event> {
        if (!id) {
            return null;
        }
        return this.gw.get('event/:id', { id: id });
    }

    get currentEvent(): Event {
        return this.eventEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('event/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.event = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('event/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.event, res.body.content) && res.body.content.length > 0) {
                        this.event = res.body.content;
                        this.onDataChanged.next(this.event);
                    }
                    else {
                        this.event = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getEventType() {
        return new Promise<any>((resolve, reject) => {
            this.gw.get('event/eventType/simpleList').subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }
    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

